var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{staticClass:"dt-border",attrs:{"value":_vm.dialog,"flat":"","max-width":"600"},on:{"input":function($event){return _vm.$emit('input',$event)}},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({attrs:{"depressed":"","color":_vm.color,"dark":""},on:{"click":_vm.doSomething}},'v-btn',attrs,false),on),[_vm._t("button")],2)]}}],null,true)},[[_vm._t("content")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }